<template>
    <div class="smr-panel" :class="{'smr-panel--autosize' : autoSize}">
        <el-dialog :visible.sync="dialogVisible" :show-close="false" @close="dialogCloseHandler" :top="dialogTopMargin">
            <div class="smr-panel__header">
                <div class="smr-panel__header__title bold-label">{{ title }}</div>
                <div class="smr-panel__actions">
                    <div class="smr-panel__actions__item smr-panel__actions__close" @click="closeClickHandler">
                        <icon><IconClose/></icon>
                    </div>
                    <div class="smr-panel__actions__item smr-panel__actions__save" @click="saveClickHandler">
                        <Loader class="smr-panel__actions__item__loader" v-if="saving"/>
                        <icon v-if="!saving"><IconCheck/></icon>
                    </div>
                </div>
            </div>
            <div class="smr-panel__body">
                <slot />
            </div>
            <div class="smr-panel__footer">
                <SmrButton class="smr-panel__footer__button" color="grey" @click.native="closeClickHandler">Abbrechen</SmrButton>
                <SmrButton class="smr-panel__footer__button" @click.native="saveClickHandler" :loading="saving">Übernehmen</SmrButton>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Loader from '@/components/Loader.vue'
import SmrButton from '@/components/SmrButton.vue'
import Icon from '@/components/Icon.vue'
import IconCheck from '@/components/icons/IconCheck.vue'
import IconClose from '@/components/icons/IconClose.vue'
import { trackEvent, trackGa4Event } from '@/utils/tracking'
import eventBus from '@/utils/event-bus';

export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        saving: {
            default: false,
            type: Boolean
        },
        autoSize: {
            default: false,
            type: Boolean
        }
    },
    components: {
        SmrButton,
        Icon,
        IconCheck,
        IconClose,
        Loader
    },
    data() {
        return {
            dialogVisible: false,
            interacted: false,
        }
    },
    computed: {
        ...mapGetters(['mobile', 'searchInputType']),
        dialogTopMargin() {
            return this.mobile ? '0' : '5vh';
        },
        trackingData() {
            let trackingContent = [];
            let label;
                if(this.searchInputType === 'Start')  label = 'Starting Point';
                else if(this.searchInputType === 'Ziel')  label = 'Destination';
                // else  label = 'Start';
                else label = 'Starting Point';
            switch(this.title) {
                case 'Arbeit': 
                    trackingContent.action = label;
                    trackingContent.label = 'Save Work Address';
                break;
                case 'Zuhause': 
                    trackingContent.action = label;
                    trackingContent.label = 'Save Home Address';
                break;
                case 'Ort als Favorit speichern': 
                    trackingContent.action = 'Search Location';
                    trackingContent.label = 'Save';
                break;
                case 'Route speichern':
                    trackingContent.action = 'Route';
                    trackingContent.label = 'Save';
                break;
                default: 
                    trackingContent.action = label;
                    trackingContent.label = '';
            }
            return trackingContent;
        }
    },
    methods: {
        dialogCloseHandler(){
            eventBus.$emit('itemClosed');
            this.emitCloseEvent();
        },
        closeClickHandler() {
            eventBus.$emit('itemClosed');
            this.closeDialog();
        },
        saveClickHandler() {
            eventBus.$emit('itemClosed');
            this.trackingEvent();
            this.saveData();
        },
        trackingEvent() {
            trackEvent({ category: 'Route Planner', action: this.trackingData.action, label: this.trackingData.label })
            const ga4EventValue = this.title === 'Ort als Favorit speichern' ?  'save_confirmed' : this.trackingData.label.replace(/ /g, "_").toLowerCase();
            const ga4EventName = this.title === 'Ort als Favorit speichern' ?  'options' : this.trackingData.action.replace(/ /g, "_").toLowerCase();
            const ga4Event = this.title === 'Ort als Favorit speichern' ?  'selected_location' : 'route_planner';
            trackGa4Event({ga4Parameter1Name: ga4EventName, ga4Parameter1Value: ga4EventValue, ga4Event: ga4Event})
        },
        showDialog() {
            this.dialogVisible = true;
            this.emitVisibilityChange()
        },
        closeDialog() {
            this.dialogVisible = false;
            this.emitVisibilityChange()
        },
        emitVisibilityChange() {
            this.$emit('visibilityChange', this.dialogVisible)
        },
        emitCloseEvent() {
            this.$emit('close');
        },
        saveData() {
            this.$emit('save');
        },
    }
}
</script>